import {
  hasAnyPermissions,
  ROUTE_PERMISSIONS,
} from 'src/utils/permissions';
import { ProfileDataMap } from 'src/types/instance';
import { User } from 'src/types/user';

export const canViewAcknowledgements = (
  permissions: string[],
): boolean => (
  hasAnyPermissions(
    permissions,
    ROUTE_PERMISSIONS.USER_ACKNOWLEDGEMENTS,
  )
);

export const findIndexOnPaginatedPages = (
  id: string | number,
  pages: any[],
): [pageIndex: number, itemIndex: number] => {
  for (let i = 0; i < pages.length; i++) {
    const itemIndex = pages[i]?.data?.findIndex((elem) => elem.id === id);

    if (itemIndex !== undefined && itemIndex !== -1) {
      return [i, itemIndex];
    }
  }

  return [-1, -1];
};

const checkEmptyDinamicField = (item) =>
  (Array.isArray(item) && item.length > 0)
  || (!Array.isArray(item) && (item !== undefined && item !== null && item[1] !== ''));

export const getProfileUserData = (
  userProfileData,
  instanceProfileData: ProfileDataMap,
): any[] => {
  if (userProfileData === undefined || instanceProfileData === undefined) {
    return null;
  }

  const profileUserData = [];

  Object.entries(userProfileData).forEach(([key, item]) => {
    if (checkEmptyDinamicField(item)) {
      const profileData = instanceProfileData[key];

      profileUserData[profileData.position - 1] = {
        id: key,
        value: item,
        name: profileData.name,
        type: profileData.type,
      };
    }
  });

  return profileUserData;
};

export const hasDescriptionProfile = (
  profileUserData: any[],
  birthdate,
  nickname,
  hasBosses,
  hasSegmentationData,
): boolean => (
  profileUserData?.length > 0
  || birthdate !== null
  || nickname !== null
  || hasBosses
  || hasSegmentationData
);

export const canSendMessage = (
  allowCreateChats: boolean,
  canViewChats: boolean,
  user: User,
  loggedUser: User
) => allowCreateChats && canViewChats && user.id !== loggedUser.id;
